<template>
  <div class="d-flex flex-column align-items-center w-100 px-1">
    <!-- トースト通知 -->
    <div class="toast-container position-fixed top-50 start-50 translate-middle p-3">
      <div class="toast" :class="{ 'show': showToast }" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-body bg-light-green text-center position-relative">
          <template v-if="isAddNotification">
            <button type="button" class="btn-close position-absolute" style="top: 8px; right: 8px;" @click="closeToast"></button>
            <div>通知リストに追加しました。</div>
            <div>召集時にお知らせします。</div>
            <div><a href="#">通知リストを確認する</a></div>
          </template>
          <template v-else-if="isMatchFinished">
            <div>試合が終了しています。</div>
            <div>召集通知はありません。</div>
          </template>
          <template v-else>
            {{ toastMessage }}
          </template>
        </div>
      </div>
    </div>
    <div class="card match-card my-1 mx-1">
      <!-- ヘッダー -->
      <div class="card-header d-flex justify-content-between align-items-center py-1 px-2"
           style="cursor: pointer"
           @click="isLoggedIn ? $emit('edit-match', match.event_id, match.match_no): null">
        <div class="d-flex align-items-center">
          <span class="match-id">{{ match.event_id }}-{{ match.match_no }}</span>
        </div>
        <div class="d-flex align-items-center">
          <span class="court-label me-1">コート</span>
          <span class="court-number me-2">{{ match.court }}</span>
          <span v-if="match.actual_court && match.actual_court !== match.court.toString()"> <font-awesome-icon icon="fa-solid fa-arrow-right" /> <span class="court-number me-2">{{ match.actual_court }}</span></span>
        </div>
      </div>

      <div class="card-body py-2 px-2" v-if="match.match_status !== 'finished'">
        <div class="d-flex">
          <div class="col-8">
            <div class="player-info d-flex align-items-center mb-2">
              <div class="team-name-container me-1">
                <TeamLabelComponent :teamId="match.left_team_id_1" :alterText="match.left_entry_id"/>
                <span v-if="match.left_team_id_2 != '' && match.left_team_id_1 != match.left_team_id_2">
                  <br><TeamLabelComponent :teamId="match.left_team_id_2"/>
                </span>
              </div>
              <div class="d-flex align-items-center">
                <div class="player-names">
                  <div class="player-name">{{ match.left_player_name_1 }}</div>
                  <div v-if="leftPlayerKana1" class="player-kana">{{ leftPlayerKana1 }}</div>
                  <div class="player-name">{{ match.left_player_name_2 }}</div>
                  <div v-if="leftPlayerKana2" class="player-kana">{{ leftPlayerKana2 }}</div>
                </div>
              </div>
            </div>
            <div class="player-info d-flex align-items-center">
              <div class="team-name-container me-1">
                <TeamLabelComponent :teamId="match.right_team_id_1" :alterText="match.right_entry_id"/>
                <span v-if="match.right_team_id_2 != '' && match.right_team_id_1 != match.right_team_id_2">
                  <br><TeamLabelComponent :teamId="match.right_team_id_2"/>
                </span>
              </div>
              <div class="d-flex align-items-center">
                <div class="player-names">
                  <div class="player-name">{{ match.right_player_name_1 }}</div>
                  <div v-if="rightPlayerKana1" class="player-kana">{{ rightPlayerKana1 }}</div>
                  <div class="player-name">{{ match.right_player_name_2 }}</div>
                  <div v-if="rightPlayerKana2" class="player-kana">{{ rightPlayerKana2 }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4 d-flex justify-content-center align-items-center called-status" v-if="match.match_status === 'called'">
            <div>招集中</div>
          </div>
          <div class="col-4 d-flex justify-content-center align-items-center called-finished-status" v-if="match.match_status === 'called_finished'">
            <div>招集済み</div>
          </div>
          <div class="col-4 d-flex justify-content-center align-items-center playing-status" v-if="match.match_status === 'playing'">
            <div>試合中</div>
          </div>
          <div class="col-4 d-flex flex-column justify-content-center align-items-center waiting-status" v-if="match.match_status == null || match.match_status === 'waiting'">
            <div class="start-time mb-1">{{ match.start }}</div>
            <!-- <div>
              <font-awesome-icon :icon="['far', 'bell']" class="text-secondary bell-icon" style="font-size: 1.2rem; cursor: pointer;" @click="toggleNotification(false)"/>
            </div> -->
          </div>
        </div>
        <!-- ノート表示 -->
        <div v-if="match.note" class="mt-2 text-muted d-flex align-items-center">
          <font-awesome-icon :icon="['fas', 'circle-info']" style="margin-left: 6px; color: #8c8c8c" class="me-1" />
          <small>{{ match.note }}</small>
        </div>

      </div>

      <!-- 試合終了の場合 -->
      <!-- ボディ -->
      <div class="card-body py-2 px-2" v-if="match.match_status === 'finished'">
        <!-- 左側プレイヤー -->
        <div class="player-row d-flex justify-content-between align-items-center mb-2">
          <div class="player-info d-flex align-items-center">
            <div class="team-name-container me-1">
              <TeamLabelComponent :teamId="match.left_team_id_1" :alterText="match.left_entry_id"/>
              <span v-if="match.left_team_id_2 != '' && match.left_team_id_1 != match.left_team_id_2">
                <br><TeamLabelComponent :teamId="match.left_team_id_2"/>
              </span>
            </div>
            <div class="d-flex align-items-center">
              <div class="player-names">
                <div class="player-name">{{ match.left_player_name_1 }}</div>
                <div v-if="leftPlayerKana1" class="player-kana">{{ leftPlayerKana1 }}</div>
                <div class="player-name">{{ match.left_player_name_2 }}</div>
                <div v-if="leftPlayerKana2" class="player-kana">{{ leftPlayerKana2 }}</div>
              </div>
            </div>
          </div>
          <div class="score-info">
            <font-awesome-icon v-if="match.winner_entry_id === match.left_entry_id" :icon="['fas', 'circle-check']" class="win-icon me-1"/>
            <span v-if="match.left_game1_score" class="score" :class="{ 'winner-score': match.game1_winner_entry_id === match.left_entry_id }">{{ match.left_game1_score }}</span>
            <span v-if="match.left_game2_score" class="score" :class="{ 'winner-score': match.game2_winner_entry_id === match.left_entry_id }">{{ match.left_game2_score }}</span>
            <span v-if="match.left_game3_score" class="score" :class="{ 'winner-score': match.game3_winner_entry_id === match.left_entry_id }">{{ match.left_game3_score }}</span>
          </div>
        </div>

        <!-- 右側プレイヤー -->
        <div class="player-row d-flex justify-content-between align-items-center">
          <div class="player-info d-flex align-items-center">
            <div class="team-name-container me-1">
              <TeamLabelComponent :teamId="match.right_team_id_1" :alterText="match.right_entry_id"/>
              <span v-if="match.right_team_id_2 != '' && match.right_team_id_1 != match.right_team_id_2">
                <br><TeamLabelComponent :teamId="match.right_team_id_2"/>
              </span>
            </div>
            <div class="d-flex align-items-center">
              <div class="player-names">
                <div class="player-name">{{ match.right_player_name_1 }}</div>
                <div v-if="rightPlayerKana1" class="player-kana">{{ rightPlayerKana1 }}</div>
                <div class="player-name">{{ match.right_player_name_2 }}</div>
                <div v-if="rightPlayerKana2" class="player-kana">{{ rightPlayerKana2 }}</div>
              </div>
            </div>
          </div>
          <div class="score-info">
            <font-awesome-icon v-if="match.winner_entry_id === match.right_entry_id" :icon="['fas', 'circle-check']" class="win-icon me-1"/>
            <span v-if="match.right_game1_score" class="score" :class="{ 'winner-score': match.game1_winner_entry_id === match.right_entry_id }">{{ match.right_game1_score }}</span>
            <span v-if="match.right_game2_score" class="score" :class="{ 'winner-score': match.game2_winner_entry_id === match.right_entry_id }">{{ match.right_game2_score }}</span>
            <span v-if="match.right_game3_score" class="score" :class="{ 'winner-score': match.game3_winner_entry_id === match.right_entry_id }">{{ match.right_game3_score }}</span>
          </div>
        </div>

        <!-- ノート表示 -->
        <div v-if="match.note" class="mt-2 text-muted d-flex align-items-center">
          <font-awesome-icon :icon="['fas', 'circle-info']" style="margin-left: 6px; color: #8c8c8c" class="me-1" />
          <small>{{ match.note }}</small>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, defineProps, computed } from 'vue'
import { getAuth, onAuthStateChanged } from 'firebase/auth'

const isLoggedIn = ref(false)

const props = defineProps({
  match: {
    type: Object,
    required: true
  },
  showKana: {
    type: Boolean,
    default: false
  },
  entries: {
    type: Object,
    default: () => ({})
  }
})

const showToast = ref(false)
const toastMessage = ref('')

const isAddNotification = ref(false)
const isMatchFinished = ref(false)

// entriesからカナを取得するcomputedプロパティ
const leftPlayerKana1 = computed(() => {
  if (!props.showKana || !props.entries || !props.match.left_entry_id || !props.match.event_id) return ''
  const entryKey = `${props.match.event_id}-${props.match.left_entry_id}`
  const entry = props.entries[entryKey]
  return entry ? entry.player_kana_1 || '' : ''
})

const leftPlayerKana2 = computed(() => {
  if (!props.showKana || !props.entries || !props.match.left_entry_id || !props.match.event_id) return ''
  const entryKey = `${props.match.event_id}-${props.match.left_entry_id}`
  const entry = props.entries[entryKey]
  return entry ? entry.player_kana_2 || '' : ''
})

const rightPlayerKana1 = computed(() => {
  if (!props.showKana || !props.entries || !props.match.right_entry_id || !props.match.event_id) return ''
  const entryKey = `${props.match.event_id}-${props.match.right_entry_id}`
  const entry = props.entries[entryKey]
  return entry ? entry.player_kana_1 || '' : ''
})

const rightPlayerKana2 = computed(() => {
  if (!props.showKana || !props.entries || !props.match.right_entry_id || !props.match.event_id) return ''
  const entryKey = `${props.match.event_id}-${props.match.right_entry_id}`
  const entry = props.entries[entryKey]
  return entry ? entry.player_kana_2 || '' : ''
})

onMounted(() => {
  const auth = getAuth()
  isLoggedIn.value = !!auth.currentUser
  onAuthStateChanged(auth, (user) => {
    isLoggedIn.value = !!user
  })
})

const closeToast = () => {
  showToast.value = false
}

const toggleNotification = (isNotifying) => {
  if (isNotifying === 'finished') {
    isMatchFinished.value = true
    showToast.value = true
    setTimeout(() => {
      showToast.value = false
    }, 3000)
    return
  }
  isMatchFinished.value = false
  isAddNotification.value = !isNotifying
  toastMessage.value = isNotifying ? '通知リストから削除しました。' : ''
  showToast.value = true
  setTimeout(() => {
    showToast.value = false
  }, isNotifying ? 3000 : 5000)
};
import TeamLabelComponent from './TeamLabelComponent.vue';
</script>

<style scoped>
.toast {
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  background: none;
}

.toast.show {
  opacity: 1;
}

.toast-body {
  padding: 0.75rem;
  font-size: 0.95rem;
}

.bg-light-green {
  background-color: cornsilk !important;
  color: #856404;
  border-radius: 0.375rem;
}

.bell-icon:hover {
  opacity: 0.7;
}
.match-card {
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  width: 100%;
  min-width: 300px;
  max-width: 400px;
}

.card-header {
  background-color: #f8f9fa;
  border-top-left-radius: 6px !important;
  border-top-right-radius: 6px !important;
}

.match-id {
  font-weight: 500;
  font-size: 1.2rem;
}

.court-label {
  font-size: 1rem;
  color: #6c757d;
}

.court-number {
  background-color: #d1e7dd;
  padding: 1px 8px;
  border-radius: 0;
  font-size: 1rem;
  min-width: 30px;
  text-align: center;
  display: inline-block;
}

.actual-court-label {
  color: #28a745;
  font-weight: bold;
  font-size: 0.9rem;
}

.start-time {
  font-size: 1.0rem;
  color: #495057;
  font-weight: normal;
}

.player-info {
  flex-grow: 1;
}

.team-name-container {
  width: 60px;
  text-align: center;
}

.player-names {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.player-name {
  font-size: 0.95rem;
  white-space: nowrap;
  line-height: 1.1;
  font-weight: 500;
}

.player-kana {
  font-size: 0.75rem;
  color: #6c757d;
  line-height: 1.0;
  margin-top: -1px;
}

.win-icon {
  color: #32cd32;
  font-size: 1rem;
  transform: translateY(-1px);
}

.score-info {
  display: flex;
  gap: 12px;
  align-items: center;
}

.score {
  min-width: 20px;
  text-align: center;
  font-weight: 500;
  font-size: 1.1rem;
}

.winner-score {
  color: #32cd32;
  font-weight: bold;
}

.called-status {
  color: #856404;
  background-color: #fff9db;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.9rem;
}

.called-finished-status {
  color: #856404;
  background-color: peachpuff;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.9rem;
}

.waiting-status {
  color: #a8a8a8;
  background-color: #f7f7f7;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.9rem;
}

.playing-status {
  color: #009baf;
  background-color: #d1faff;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.9rem;
}
</style>